import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import SEOHead from '@/components/marketplace/SEOHead';
import { resolveEffectiveOgImage, absoluteUrl } from '@/lib/ogImage';

const StaticPage = ({ page }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api.get(`/static-pages/by-slug/${page}`)
      .then(r => setData(r.data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [page]);
  return (
    <div className='indus-container py-10'>
      {data && (
        <SEOHead
          title={data.meta_title || `${data.title} | IndusFact`}
          description={data.meta_description || ''}
          canonical={data.canonical_url || (typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : undefined)}
          robots={data.robots_meta || undefined}
          image={absoluteUrl(resolveEffectiveOgImage(data, 'page'))}
        />
      )}
      <Card className='p-8 sm:p-10 max-w-5xl mx-auto' data-testid={`static-page-${page}`}>
        {loading ? (
          <div className='text-muted-foreground'>Loading…</div>
        ) : notFound ? (
          <>
            <h1 className='text-2xl sm:text-3xl font-semibold tracking-tight capitalize'>{page}</h1>
            <p className='text-sm text-muted-foreground mt-4'>
              This page is being updated. Please check back shortly.
            </p>
          </>
        ) : (
          <>
            <h1 className='text-2xl sm:text-3xl font-semibold tracking-tight'>{data.title}</h1>
            <div
              className='indus-prose mt-6 text-[15px] leading-7'
              dangerouslySetInnerHTML={{ __html: data.html_content || '' }}
            />
          </>
        )}
      </Card>
    </div>
  );
};

export default StaticPage;

// Small wrapper for the sitemap-friendly `/policy/:slug` route — Razorpay's
// crawler follows the sitemap URLs, so this catch-all keeps every current
// AND future static page reachable at both `/{slug}` and `/policy/{slug}`.
import { useParams } from 'react-router-dom';
export const StaticPageBySlug = () => {
  const { slug } = useParams();
  return <StaticPage page={slug} />;
};
